// Optional theme features load only on pages that actually render them.
// Recheck explicit rendering events, not every mutation in the document.
const config = document.getElementById('nv-component-modules');
const modules = config ? JSON.parse(config.textContent) : {};
const pending = new Map();
function scan() {
  for (const [selector, url] of Object.entries(modules)) {
    if (pending.has(url) || !document.querySelector(selector)) continue;
    const request = import(url).catch(error => {
      pending.delete(url);
      console.error('Optional theme component failed to load', selector, error);
    });
    pending.set(url, request);
  }
}
let queued = false;
function scheduleScan() {
  if (queued) return;
  queued = true;
  queueMicrotask(() => { queued = false; scan(); });
}
scan();
for (const event of ['dialog:open', 'filter:update', 'variant:update', 'cart:update', 'shopify:section:load']) {
  document.addEventListener(event, scheduleScan);
}
// Retry failed module requests after connectivity is restored.
window.addEventListener('online', scheduleScan);
